import { inject } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import { CanActivateFn, Router, UrlTree } from '@angular/router'

import { environment } from 'apps/designer/src/environments/environment'

import { Observable, filter, first, map, of, take } from 'rxjs'

import { FlxModalService } from '@flowx/angular-ui-toolkit'
import { EnumerationService } from '@flowx/designer/modules/ui-designer/services/enumerations.service'
import { ConfirmationModalComponent } from '@flowx/designer/shared/components/confirmation-modal/confirmation-modal.component'

import { FlxThemeUpdatesService } from './services/theme-updates.service'

import { WorkspacesAndPermissionsStore } from '../workspaces/workspaces-and-permissions.store'

export const themeCanDeactivateGuard = (): Observable<boolean> => {
  const modalService = inject(FlxModalService)
  const updatesService = inject(FlxThemeUpdatesService)
  const showConfirmModal$ = (): any =>
    modalService
      .show(
        ConfirmationModalComponent,
        { closeOnBackdropClick: false, backdropClass: 'overlay-backdrop' },
        {
          title: `Changes Unsaved`,
          message: `You have unsaved changes. Are you sure you want to exit page?`,
          btnOkText: `Discard Changes`,
          modalClass: 'pending-changes',
        }
      )
      .data$.pipe(
        first(),
        map(({ confirm }) => confirm)
      )
  return updatesService.themeUpdates ? showConfirmModal$() : of(true)
}

export function themeCanActivateGuard(): CanActivateFn {
  return (): Observable<boolean | UrlTree> => {
    // TODO Theming: Check where this call should be triggered, in a resolver in
    inject(EnumerationService)
      .getGlobalStaticAssets(environment.baseUrl, environment.staticAssetsPath)
      .subscribe()

    const router = inject(Router)
    const workspacesAndPermissionsStore = inject(WorkspacesAndPermissionsStore)

    // TODO return a signal once Angular supports it
    return toObservable(workspacesAndPermissionsStore.workspacePermissions.value).pipe(
      filter(Boolean),
      take(1),
      map((permissions) => {
        const isPermitted = permissions['theme_read']
        return isPermitted ? true : router.parseUrl('/403')
      })
    )
  }
}
